/**
 * Technology Speed Check Reducers
 */
import {
    SPEEDCHECK_ACTION,
    ALL_SPEEDCHECK,
    ADD_SPEEDCHECK,
    FETCH_SPEEDCHECK,
    EDIT_SPEEDCHECK,
    DELETE_SPEEDCHECK
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    speedchecklist:[],
    particularspeedcheck:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case SPEEDCHECK_ACTION:
            return { ...state, loading: true };       

        case ALL_SPEEDCHECK:
            return { ...state, loading: false, speedchecklist: action.payload || [] };     
            
        case ADD_SPEEDCHECK:
            return { ...state, loading: false };     
         
        case FETCH_SPEEDCHECK:
            return { ...state, loading: false, particularspeedcheck: action.payload };  
            
        case EDIT_SPEEDCHECK:
            return { ...state, loading: false }; 
            
        case DELETE_SPEEDCHECK:
            return { ...state, loading: false };     
        
        default: return { ...state };

     }
 }